export const DEFAULT_PROFILE_AVATAR = '/images/avatars/pp_boy.svg';
export const DEFAULT_PROFILE_AVATAR_GIRL = '/images/avatars/pp_girl.svg';

export const resolveProfileAvatarFallback = (image) => {
  const trimmed = image && String(image).trim();
  if (trimmed && trimmed.includes('pp_girl')) {
    return DEFAULT_PROFILE_AVATAR_GIRL;
  }
  return DEFAULT_PROFILE_AVATAR;
};

export const resolveProfileAvatarSrc = (image) => {
  const trimmed = image && String(image).trim();
  return trimmed || resolveProfileAvatarFallback(image);
};

const avatars = [
  '/images/avatars/pp_girl.svg',
  '/images/avatars/pp_girl.svg',
  '/images/avatars/pp_girl2.svg',
  '/images/avatars/pp_girl3.svg',
  '/images/avatars/pp_girl4.svg',
  '/images/avatars/pp_girl5.svg',
  '/images/avatars/pp_boy.svg',
  '/images/avatars/pp_boy2.svg',
  '/images/avatars/pp_boy3.svg',
  '/images/avatars/pp_boy4.svg',
  '/images/avatars/pp_boy5.svg',
];

export default avatars;
